import { TextField } from "@material-ui/core";
import React from "react";
import { NumericFormat } from "react-number-format";

type Variant = "outlined" | "standard" | "filled" | undefined;

type Props = {
  value: number | string;
  onChange: (valor: number) => void;
  label: string;
  maxLength?: number;
  submit?: () => void;
  fullWidth?: boolean;
  type?: "money" | "number";
  decimalScale?: number;
  prefix?: string;
  suffix?: string;
  mask?: string;
  variant?: Variant;
  textAlign?: "center" | "left" | "right";
  autoSelect?: boolean;
  style?: React.CSSProperties;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  helperText?: string;
  error?: boolean | undefined;
};

const NumberFieldGeneric: React.FC<Props> = (props) => {
  const {
    value,
    maxLength,
    submit,
    fullWidth,
    type,
    onChange,
    decimalScale,
    prefix,
    suffix,
    variant,
    textAlign,
    autoSelect,
    label,
    disabled,
    required,
    error,
    helperText,
    ...other
  } = props;
  // const [focused, setFocused] = useState(false);

  let newVariant: Variant = variant;
  if (!newVariant) {
    newVariant = "outlined";
  } else if (newVariant === "standard") {
    newVariant = undefined;
  }

  // return null;
  let newValue = value;
  if (typeof value !== "string" && typeof value !== "number") {
    newValue = 0;
  }
  if (typeof newValue === "string") {
    newValue = parseFloat(newValue);
    if (!newValue) {
      newValue = 0;
    }
  }

  return (
    <NumericFormat
      prefix={type === "money" ? "R$ " : prefix}
      suffix={suffix}
      decimalScale={type === "money" ? 2 : decimalScale}
      decimalSeparator={","}
      thousandSeparator={"."}
      fixedDecimalScale={type === "money" ? true : false}
      value={newValue}
      fullWidth={fullWidth === false ? false : true}
      variant={newVariant}
      label={label}
      error={error}
      helperText={helperText}
      {...other}
      customInput={TextField}
      inputProps={{
        // type: 'number',
        maxLength,
        style: {
          textAlign,
        },
      }}
      disabled={disabled}
      required={required}
      onFocus={(e) => {
        if (autoSelect) {
          if (suffix === undefined) {
            e.target.select();
          } else {
            setTimeout(() => {
              e.target.select();
            }, 200);
          }
        }
      }}
      onValueChange={(value) => {
        if (!value.floatValue) {
          value.floatValue = 0;
        }
        const event = { target: { value: value.floatValue } };
        onChange(value.floatValue);
      }}
    />
  );
};

export default NumberFieldGeneric;
